<div class="container">
  <img  class="img-fluid text-center"
      src="assets/images/construccion.png"
      alt="">
</div>
